<template>
    <div>
        <div class="button-area">
            <el-button @click="selectAllWeek" type="primary" size="small">全选</el-button>
            <el-button @click="selectOddWeek" type="primary" size="small">单周</el-button>
            <el-button @click="selectEvenWeek" type="primary" size="small">双周</el-button>
            <el-button @click="selectOtherWeek" type="warning" size="small">反选</el-button>
            <el-button @click="clearSelectWeek" type="danger" size="small">清空</el-button>
        </div>
        <div class="week-area">
            <table class="weekTable">
                <tr v-for="n in Math.floor(weekInfo.length/3) + (weekInfo.length%3 > 0 ? 1 : 0)">
                    <td class="weekNum"
                        :id="'week_' + ((n-1)*3 + m)"
                        v-for="m in 3"
                        v-if="weekInfo.length > ((n-1)*3 + (m-1))"
                        :title="weekInfo[((n-1)*3 + (m-1))].tips"
                        :style="{backgroundColor: weekInfo[((n-1)*3 + (m-1))].cellColor}"
                        @mouseenter="handleMouseEnter"
                        @mouseleave="handleMouseLeave"
                        @mouseover="handleMouseOver"
                        @mouseout="handleMouseOut"
                        @click="handleClick">
                        {{ (n-1)*3 + m }}
                    </td>
                </tr>
            </table>
        </div>
        <div slot="footer" class="dialog-footer" style="float:right; margin-top:10px">
            <el-button type="primary" @click="confirm">确定</el-button>
            <el-button @click="closeDialog">取消</el-button>
        </div>
    </div>
</template>

<script>
    import { confirmMsg, showNotify } from "utils/message";
    import * as commonTools from "utils/timetableCommon";

    export default {
        data() {
            return {
                queryForm: {
                    semesterCode: null,
                    classCode: null,
                    timeOrder: null,
                    teaCode: null,
                    siteCode: null,
                },
                weekInfo: [],
                weekUsedInfo: [],
                teachingWeekNum: 0,
                oddWeekArray: [],
                evenWeekArray: [],
                cellOriColor: null,
                curCellWeekInfo: null,
                curWeekInfo: null,
                curTitle: null,
                selectedColor: '#E7FECB',
                unselectedColor: '#FFFFFF',
                disabledColor: '#AAAAAA',
            }
        },
        mounted() {
        },
        methods: {
            queWeekUsedInfo(){
                this.$api.timetableManage.arrange.queWeekUsedInfo({
                    data: this.queryForm
                }).then((response) => {
                    this.weekUsedInfo = response.data.data;
                    this.initWeekInfo();
                }).catch(error => {
                    console.log(error);
                });
            },
            initWeekInfo(){
                for(let i=0; i<this.teachingWeekNum; i++){
                    let weekName = i+1;
                    let weekObj = {
                        name: weekName,
                        disabled: false,
                        selected: false,
                        tips: null,
                        cellColor: this.unselectedColor,
                    };

                    //判断是否为当前选中的周次
                    if(this.curWeekInfo.indexOf(weekObj.name) > -1){
                        weekObj.selected = true;
                        weekObj.cellColor = this.selectedColor;
                    }else{
                        //判断是否为当前课程的周次
                        if(this.curCellWeekInfo.indexOf(weekObj.name) > -1){
                            weekObj.disabled = true;
                            weekObj.tips = '本班该周次已安排其他课程';
                            weekObj.cellColor = this.disabledColor;
                        }else{
                            //判断是否为教师或场地被占用的周次
                            for(let j=0; j<this.weekUsedInfo.length; j++){
                                if(this.weekUsedInfo[j].weekNum == weekName){
                                    weekObj.disabled = true;
                                    weekObj.tips = this.weekUsedInfo[j].tips.replace(/\@/g, '\n');
                                    weekObj.cellColor = this.disabledColor;
                                    break;
                                }
                            }
                        }
                    }

                    this.weekInfo.push(weekObj);
                }
            },
            handleMouseEnter(ele){
                //获取title属性的内容
                this.curTitle = $('#' + ele.srcElement.id).attr('title');

                if(this.curTitle){
                    //设置元素title属性内容为空
                    $('#' + ele.srcElement.id).attr('title', '');

                    $("body").append("<div id='div_toop'>" + this.curTitle.replace(/\n/g, '<br>') + "</div>");
                    $("#div_toop").css({
                        "position": "absolute",
                        "z-index": 999999,
                        "font-size": 12,
                        "background": "rgba(245, 245, 245, 0.9)",
                        "border": "solid 1px #A9A9A9",
                        "border-radius": "5px",
                        "padding": "5px",
                        "max-width": "200px"
                    });
                    $('#div_toop').css("top", $('#' + ele.srcElement.id).offset().top-$('#div_toop').height()+10 + "px");
                    $('#div_toop').css("left", $('#' + ele.srcElement.id).offset().left-$('#div_toop').width()+10 + "px");
                }
            },
            handleMouseLeave(ele){
                $('#' + ele.srcElement.id).attr('title', this.curTitle);
                this.curTitle = null;
                $("#div_toop").remove();
            },
            handleMouseOver(ele){
                const index = ele.srcElement.id.substring(ele.srcElement.id.indexOf('_') + 1) - 1;

                if(!this.weekInfo[index].disabled){
                    this.cellOriColor = $(ele.srcElement).css('background-color');
                    $(ele.srcElement).css('background-color', '#FFE48D');
                }
            },
            handleMouseOut(ele){
                if(this.cellOriColor){
                    $(ele.srcElement).css('background-color', this.cellOriColor);
                    this.cellOriColor = null;
                }
            },
            handleClick(ele){
                const index = ele.srcElement.id.substring(ele.srcElement.id.indexOf('_') + 1) - 1;

                if(!this.weekInfo[index].disabled){
                    if(this.weekInfo[index].selected){
                        this.weekInfo[index].selected = false;
                        this.weekInfo[index].cellColor = this.unselectedColor;
                        this.cellOriColor = this.unselectedColor;
                    }else{
                        this.weekInfo[index].selected = true;
                        this.weekInfo[index].cellColor = this.selectedColor;
                        this.cellOriColor = this.selectedColor;
                    }
                }
            },
            selectAllWeek(){
                for(let i=0; i<this.weekInfo.length; i++){
                    if(!this.weekInfo[i].disabled){
                        this.weekInfo[i].selected = true;
                        this.weekInfo[i].cellColor = this.selectedColor;
                    }
                }
            },
            selectOddWeek(){
                for(let i=0; i<this.weekInfo.length; i++){
                    if(!this.weekInfo[i].disabled){
                        if(this.oddWeekArray.indexOf(this.weekInfo[i].name) > -1){
                            this.weekInfo[i].selected = true;
                            this.weekInfo[i].cellColor = this.selectedColor;
                        }else{
                            this.weekInfo[i].selected = false;
                            this.weekInfo[i].cellColor = this.unselectedColor;
                        }
                    }
                }
            },
            selectEvenWeek(){
                for(let i=0; i<this.weekInfo.length; i++){
                    if(!this.weekInfo[i].disabled){
                        if(this.evenWeekArray.indexOf(this.weekInfo[i].name) > -1){
                            this.weekInfo[i].selected = true;
                            this.weekInfo[i].cellColor = this.selectedColor;
                        }else{
                            this.weekInfo[i].selected = false;
                            this.weekInfo[i].cellColor = this.unselectedColor;
                        }
                    }
                }
            },
            selectOtherWeek(){
                for(let i=0; i<this.weekInfo.length; i++){
                    if(!this.weekInfo[i].disabled){
                        if(this.weekInfo[i].selected){
                            this.weekInfo[i].selected = false;
                            this.weekInfo[i].cellColor = this.unselectedColor;
                        }else{
                            this.weekInfo[i].selected = true;
                            this.weekInfo[i].cellColor = this.selectedColor;
                        }
                    }
                }
            },
            clearSelectWeek(){
                for(let i=0; i<this.weekInfo.length; i++){
                    if(!this.weekInfo[i].disabled){
                        this.weekInfo[i].selected = false;
                        this.weekInfo[i].cellColor = this.unselectedColor;
                    }
                }
            },
            confirm() {
                let finalWeekArray = [];
                for(let i=0; i<this.weekInfo.length; i++){
                    if(this.weekInfo[i].selected){
                        finalWeekArray.push(this.weekInfo[i].name);
                    }
                }

                if(finalWeekArray.length === 0){
                    this.$message({
                        message: '请选择上课周次',
                        type: 'error'
                    });
                    return;
                }

                this.$emit('updateWeekInfo', commonTools.convertWeekArrayToStr(finalWeekArray));
            },
            //关闭对话框
            closeDialog() {
                this.$emit('closeWeekSettingDialog');
            },
        },
    }
</script>

<style scoped>
    .button-area {
        width: 100%;
        text-align: center;
        margin-top: 10px;
    }

    .week-area {
        height: 360px;
        overflow: auto;
        margin-top: 20px;
    }

    .weekTable {
        width: 100%;
        border-collapse: collapse;
        border-spacing: 0;
    }

    .weekNum {
        width: calc(100% / 3);
        height: 50px;
        font-weight: bold;
        border: 1px solid #DCDFE6;
        text-align: center;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// weekSetting.vue?6e1eef52